import { IPurchaseTermsResponse } from 'shared/types/purchaseTerm/purchaseTermsV2';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingExtraPricesActions {
  SetExtraPrices = 'newbuildingExtraPrices/setExtraPrices',
}

export const setNewbuildingExtraPrices = actionGenerator<
  ENewbuildingExtraPricesActions.SetExtraPrices,
  IPurchaseTermsResponse
>(ENewbuildingExtraPricesActions.SetExtraPrices);

export type TNewbuildingExtraPricesActions = ReturnType<typeof setNewbuildingExtraPrices>;
